import api from "@/axios";

export default {
  findAll() {
    return api().get("horse");
  },
  findOne(id) {
    return api().get(`admin/horse/${id}`);
  },
  create(data) {
    return api().post("admin/horse/add", data);
  },
  update(id, data) {
    return api().patch(`admin/horse/${id}`, data);
  },
  remove(id) {
    return api().delete(`admin/horse/${id}`);
  },
};
